import { render, staticRenderFns } from "./CmgCheckout.vue?vue&type=template&id=3efae55a&scoped=true&lang=pug"
import script from "./cmg-checkout.ts?vue&type=script&lang=ts&external"
export * from "./cmg-checkout.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCheckout.vue?vue&type=style&index=0&id=3efae55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efae55a",
  null
  
)

export default component.exports